<div class="flex flex-col gap-4">
  <div class="flex flex-row gap-4">
    <mat-form-field class="flex grow bg-white" subscriptSizing="dynamic">
      <mat-label>Search</mat-label>
      <input matInput type="text" [formControl]="searchCtrl" />
      @if (searchCtrl.value) {
        <button
          class="opacity-50"
          matSuffix
          mat-icon-button
          matTooltip="Clear"
          (click)="searchCtrl.setValue('')"
        >
          <mat-icon>close</mat-icon>
        </button>
      }
    </mat-form-field>

    <ng-content />
  </div>

  @if (search.noResults$ | async) {
    <div
      class="flex flex-col items-center rounded border border-solid border-gray-200 bg-white"
    >
      <pr-empty-state image="list" title="custom reports" />
    </div>
  } @else {
    <div class="overflow-hidden rounded border border-solid border-gray-200">
      <mat-table
        [trackBy]="trackByRef"
        [dataSource]="table.dataTable.dataSource"
      >
        <mat-row
          *matRowDef="let record; columns: table.dataTable.displayColumns"
        />

        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef mat-header-cell>
            Name
          </mat-header-cell>
          <mat-cell *matCellDef="let row" mat-cell class="!max-w-[350px]">
            <div class="flex max-w-[350px] flex-col py-1">
              <div
                class="text-wrap w-full"
                [ptTruncateTooltip]="row.customReport.name"
              >
                <a
                  [routerLink]="[
                    '/reporting',
                    'custom-reports',
                    row.customReport.ref.id
                  ]"
                >
                  {{ row.customReport.name }}
                </a>
              </div>
              <div class="text-xs opacity-70">
                @if (row.customReport.creator) {
                  {{ row.customReport.creator.name | prObfuscate: 'name' }} -
                }
                {{
                  row.customReport.createdAt | moment | amDateFormat: dateFormat
                }}
              </div>
            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="description">
          <mat-header-cell *matHeaderCellDef mat-header-cell>
            Description
          </mat-header-cell>
          <mat-cell *matCellDef="let row" mat-cell>
            <div class="text-xs">
              @if (row.customReport.description; as description) {
                {{ description }}
              } @else {
                <span class="italic">No description</span>
              }
            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="scopes">
          <mat-header-cell *matHeaderCellDef mat-header-cell
            >Scopes</mat-header-cell
          >
          <mat-cell *matCellDef="let row" mat-cell>
            <pr-custom-report-scopes
              [scopes]="row.scopes"
              [highlightScope]="selectByScope()"
            />
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="summary">
          <mat-header-cell *matHeaderCellDef>Summary</mat-header-cell>
          <mat-cell
            *matCellDef="let row"
            mat-cell
            class="align-right !max-w-[160px] !px-2"
          >
            <div class="flex gap-1">
              <div #filterTooltipOrigin="cdkOverlayOrigin" cdkOverlayOrigin>
                <pr-icon-chip
                  class="pointer-events-none"
                  icon="filter_list"
                  iconOnly
                />
              </div>

              @if (row.customReport | map: getDataSource; as dataSource) {
                <pr-data-source-display [dataSource]="dataSource" />
              }
            </div>

            <pt-custom-tooltip [target]="filterTooltipOrigin">
              <div class="p-2">
                <pr-pre-selected-filters
                  [customReport]="row.customReport"
                  [columnLayout]="true"
                />
              </div>
            </pt-custom-tooltip>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="select">
          <mat-header-cell
            *matHeaderCellDef
            mat-header-cell
            class="max-w-[128px] justify-end"
          />
          <mat-cell
            *matCellDef="let row"
            mat-cell
            class="max-w-[128px] justify-end"
          >
            <div
              matTooltip="This Custom Report does not match the Campaign's scope"
              [matTooltipDisabled]="!row.isDisabled"
            >
              <button
                mat-flat-button
                color="primary"
                class="whitespace-nowrap"
                [disabled]="row.isDisabled"
                (click)="reportSelected.emit(row.customReport)"
              >
                Use Report
              </button>
            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef mat-header-cell>
            Actions
          </mat-header-cell>
          <mat-cell
            *matCellDef="let row"
            mat-cell
            class="!max-w-[60px] justify-end !px-2"
          >
            <button
              mat-icon-button
              [matMenuTriggerFor]="moreMenu"
              [matMenuTriggerData]="{ customReport: row.customReport }"
            >
              <mat-icon>more_vert</mat-icon>
            </button>
          </mat-cell>
        </ng-container>
      </mat-table>
    </div>
    <mat-paginator
      #paginator
      class="!bg-transparent"
      showFirstLastButtons
      [pageSize]="table.pageSize$ | async"
      [pageSizeOptions]="table.dataTable.pageSizeOptions"
      (page)="table.updatePage($event)"
    />
  }
</div>

<mat-menu #moreMenu="matMenu">
  <ng-template let-customReport="customReport" matMenuContent>
    @if (customReport | map: isInDraft) {
      <button mat-menu-item (click)="publishReport(customReport)">
        <mat-icon
          fontSet="material-symbols-outlined"
          class="!text-green-700 opacity-90"
        >
          check_circle
        </mat-icon>
        Publish
      </button>
      <button mat-menu-item (click)="deleteReport(customReport)">
        <mat-icon
          fontSet="material-symbols-outlined"
          class="!text-warn-500 opacity-90"
        >
          delete
        </mat-icon>
        <span class="text-warn-500">Delete</span>
      </button>
    } @else {
      <button mat-menu-item (click)="revertToDraft(customReport)">
        <mat-icon fontSet="material-symbols-outlined" class="opacity-90">
          unpublished
        </mat-icon>
        Revert to Draft
      </button>
    }
  </ng-template>
</mat-menu>
